import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { clearUserGroupStore } from 'reducers/userGroup/reducer'
import UserGroupList from './UserGroupList'
import UserGroupForm from './UserGroupForm'

function UserGroup(props) {
  const {
    match: {
      params: { id },
    },
    clearUserGroupStore,
  } = props
  const Content = id ? UserGroupForm : UserGroupList

  useEffect(
    () => () => {
      clearUserGroupStore()
    },
    [],
  )

  return (
    <div className="content">
      <Content {...props} />
    </div>
  )
}

UserGroup.propTypes = {
  clearUserGroupStore: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
}

export default connect(null, {
  clearUserGroupStore,
})(UserGroup)
